<template>
    <div class="cb-step faq">
        <div class="cb-step-header">
            <div class="cb-step-icon"></div>
            <div class="cb-step-title">{{ $t('frm_ai_intro') }}</div>
            <div class="cb-step-sub-title">{{ $t('frm_ai_select_faq') }} {{ getItem('versionName') }}</div>
        </div>
        <div class="cb-disclaimer">
          <div class="cb-disclaimer-text">
            <span class="important">{{ $t('frm_important') }}:&nbsp;</span>
            <span v-html="$t('frm_ai_disclaimer', [disclaimerURL])"></span>
          </div>
        </div>
        <div class="cb-step-body">
            <Loading :active="getItem('loadFaqProcessing')"
                :is-full-page="false" loader="spinner" color='black' :width="40" :height="40"
                :can-cancel="false"
                :lock-scroll="true"
                backgroundColor="none"
                :opacity="0.9"
                :z-index=999
            />
            <div class="cb-list">
                <ul v-if="getItem('itemId')" class="faq">
                    <li v-for="(faq, index) in getFaqs" :key="index" @click="handleFaqSelection(faq)" :class="['with-icon', getItem('faq') == faq ? 'selected': '']" >{{faq}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import i18n from "@/plugins/i18n";
    import Loading from 'vue-loading-overlay';
    import { createNamespacedHelpers } from 'vuex';
    const { mapActions: aiChatMapActions, mapGetters: aiChatMapGetters } = createNamespacedHelpers('aichat')
    export default {
        name: "ChatFaqSelection",
        components: {
            Loading
        },
        computed: {
            ...aiChatMapGetters([
                'getItem'
            ]),
            getFaqs() {
                return [i18n.t('frm_faq1'), i18n.t('frm_faq2'), i18n.t('frm_faq3'), i18n.t('frm_faq4'), i18n.t('frm_faq5')];
            }
        },
        methods: {
            ...aiChatMapActions([
                'setItem',
                'sendPromptToAI'
            ]),
            handleFaqSelection(faq) {
                this.setItem({field: 'faq', value: faq});
                this.setItem({field: 'userMessage', value: faq});
                this.setItem({field: 'wizardStep', value: 'chat-messaging'});
                this.setItem({field: 'userMessage', value: ''});
                this.sendPromptToAI(faq);
            }
        },
        data() {
            return {
              disclaimerURL: '/help/knowledge-base/ai-assistant-guide',
            }
        },
    }
</script>
